export enum SubscriptionStatus {
  None = 0,
  Active = 1,
  Trialing = 2,
  PastDue = 3,
  Paused = 4,
  /// <summary>
  /// Indicates that a subscription has been cancelled
  /// </summary>
  Deleted = 5,
}
